import React, {useState} from 'react';
import {Button, CardContent, Flex, FlexItem, IconButton, Tag} from "@chatui/core";
import './calendar.css';

function Calendar(props) {

    const {
        editableRange,
        language,
        value,
        setValue,
        optionList,
        // 输出格式中的年月日中间的分隔符
        seperator = '-',
    } = props;

    //获取当前时间，格式YYYY-MM-DD
    const getNowFormatDate = (date) => {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        return year + seperator + month + seperator + strDate;
    }

    const [currentMonth, setCurrentMonth] = useState(new Date());

    // 获取今天的日期（用于高亮显示）
    const today = new Date();
    const todayString = today.toDateString();

    const curDate = today.getDate();
    const endOfEditableDate = new Date(today);
    endOfEditableDate.setDate(curDate+editableRange);


    function isDateInRange(checkDate, startDate=today, endDate=endOfEditableDate) {
        return checkDate >= startDate && checkDate <= endDate;
    }

    // 获取当前月份的第一天
    const firstDayOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
    // 获取当前月份的最后一天
    const lastDayOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);
    // 获取当前月份第一天是星期几（0-6，0代表周日）
    const firstDayOfWeek = firstDayOfMonth.getDay();

    const optionStatus = ["success", "danger", "warning", "primary"];
    const defaultStatus = optionStatus[optionStatus.length-1];
    const editableStatus = "primary"

    const [selectedDate, setSelectedDate] = useState(undefined);
    const [disable, setDisable] = useState(true);


    // 生成日历数据
    const generateCalendar = () => {
        const days = [];
        const maxRows = 6;
        const daysPerWeek = 7;
        const totalDays = maxRows*daysPerWeek;
        for (let i=0; i<maxRows;i++)
            days.push([])
        let row = 0;
        let col = 0;

        // 添加上个月的最后几天
        const prevMonthLastDay = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 0).getDate();
        for (let i = firstDayOfWeek - 1; i >= 0; i--) {
            const date = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, prevMonthLastDay - i);

            if (col>=daysPerWeek) {
                row += 1;
                col = 0
            }
            let color = defaultStatus;
            let disable = true;

            if (isDateInRange(date)) {
                color = editableStatus;
                disable = false;
            }
            days[row].push({
                date: date,
                isCurrentMonth: false,
                isToday: date.toDateString() === todayString,
                disable: disable,
                color: color
            });
            col += 1
        }

        // 添加当前月的所有天
        for (let i = 1; i <= lastDayOfMonth.getDate(); i++) {
            const date = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), i);
            if (col>=daysPerWeek) {
                row += 1;
                col = 0
            }
            const isToday = date.toDateString() === todayString;

            let color = defaultStatus;
            let disable = true;
            if (isToday){
                color = optionStatus[0];
                disable = false;
            }
            else if (isDateInRange(date)) {
                color = editableStatus;
                disable = false;
            }

            const curDay = {
                date: date,
                isCurrentMonth: true,
                isToday: date.toDateString() === todayString,
                disable: disable,
                color: color

            }
            days[row].push(curDay);
            col += 1
        }

        // 添加下个月的前几天
        const remainingDays = totalDays - (row)*daysPerWeek-col;
        for (let i = 1; i <= remainingDays; i++) {
            const date = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, i);
            if (col>=daysPerWeek) {
                row += 1;
                col = 0
            }
            let color = defaultStatus;
            let disable = true;

            if (isDateInRange(date)) {
                color = editableStatus;
                disable = false;
            }
            days[row].push({
                date: date,
                isCurrentMonth: false,
                isToday: date.toDateString() === todayString,
                disable: disable,
                color: color
            });
            col += 1
        }
        return days;
    };

    const setDateStatus = (dateString, option) => {

        const newSelectedDays = {...value};
        newSelectedDays[dateString] = option;
        setValue(newSelectedDays);
    };

    const handlePrevMonth = () => {
        setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
    };

    const handleNextMonth = () => {
        setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
    };

    const calendarDays = generateCalendar();
    let yearText = "";
    let notice = `*Currently only supports setting the status for the next ${editableRange} days`
    let weekDays = ["Sun.", "Mon.", "Tue.", "Wed.", "Thu.", "Fri.", "Sat."];
    let monthNames = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
    if (language==="zh_cn") {
        notice = `"*目前仅支持设置天${editableRange}内的店铺状态"`
        yearText = "年";
        weekDays = ['日', '一', '二', '三', '四', '五', '六'];
        monthNames = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'];
    }

    return (
        <div>
            {/* 月份导航 */}
            <p>{notice}</p>
            <Flex center>
                <IconButton icon={'chevron-left'} onClick={handlePrevMonth}></IconButton>
                {currentMonth.getFullYear()}{yearText} {monthNames[currentMonth.getMonth()]}
                <IconButton icon={'chevron-right'} onClick={handleNextMonth}></IconButton>
            </Flex>

            {/* 星期标题 */}
            <Flex center>
                {weekDays.map((day, index) => (
                    <FlexItem key={index}>
                        <div style={{"textAlign": "center"}} key={day} className="week-day">{day}</div>
                    </FlexItem>
                ))}
            </Flex>

            {/* 日期网格 */}
            <div >
                {calendarDays.map((week, weekIndex)=>(
                    <Flex className={"calendar-row"} key={weekIndex} justifyContent={"center"}>
                        {week.map((day, dayIndex)=>{
                            const dateString = getNowFormatDate(day.date);
                            return (
                                <FlexItem key={dayIndex}>
                                    {day.disable? (
                                    <Button
                                        className={"not-editable-date"}
                                        size={'lg'}
                                        disabled={true}
                                        variant={'text'}
                                    >
                                        <Tag>
                                            {day.date.getDate()}
                                        </Tag>
                                    </Button>):(
                                    <Button
                                        className={"editable-date"}
                                        onClick={() => {
                                            setSelectedDate(getNowFormatDate(day.date));
                                            setDisable(false);
                                        }}
                                        size={'lg'}
                                        disabled={false}
                                        variant={'text'}
                                    >
                                        <Tag
                                            color={optionStatus[value[dateString]]}
                                        >
                                            {day.date.getDate()}
                                        </Tag>
                                    </Button>
                                    )}
                                </FlexItem>
                            );
                        })}
                    </Flex>
                ))}
                <CardContent className={"status-options"}>
                    <p>Options</p>
                    {optionList.map((option, op_idx)=>(
                        <Button
                            key={op_idx}
                            disabled={disable}
                            onClick={()=>setDateStatus(selectedDate, op_idx)}
                        >
                            <Tag
                                color={optionStatus[op_idx]}
                            ></Tag>
                            {option}
                        </Button>
                    ))}
                </CardContent>
            </div>
        </div>
    );
}

export default Calendar;